import { adminApi } from "../apiAdmin";
import type { FactorDef } from "../types/ambassadors";

// Admin → Ambassadors: the shared settings (server lib/admin/ambassadorOffers.js)
// — the Strategic Influence Score's factor names and weights, and the
// company-wide revenue-share budget. Each is null until someone saves it, and
// the dashboard uses its defaults until then. A save sends either or both.
const PATH = "/ambassador-settings";

export const ambassadorSettingsApi = {
  get: () => adminApi.get<{ factors?: unknown; budgetPct?: unknown }>(PATH).then((r) => r.data),
  save: (patch: { factors?: FactorDef[]; budgetPct?: number }) => adminApi.put<unknown>(PATH, patch).then((r) => r.data),
};
